module.exports = __webpack_public_path__ + "img/icon_ysgl.40305b92.png";